import {
  Component,
  Input,
  TemplateRef,
  ContentChildren,
  QueryList,
  ChangeDetectionStrategy
} from '@angular/core';


export class SkyLinkRecordsItemContentComponent {
  private inputTemplate: TemplateRef<any>;
   private templates: QueryList<TemplateRef<any>>;
   public set template(value) { this.inputTemplate = value; }
  public get template() {
    return this.templates.length > 0 ? this.templates.first : this.inputTemplate;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-link-records-item-content',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'templates': [{ type: ContentChildren, args: [TemplateRef, ] },],
'template': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
